module.exports = Redux;


//////////////////
// WEBPACK FOOTER
// external "Redux"
// module id = 33
// module chunks = 0